var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ml-2 btn btn-square text-nowrap comment-trigger d-flex justify-content-center align-items-center",class:{
    'btn-purple' : _vm.unread.length && !_vm.showing,
    'btn-secondary' : !_vm.unread.length || _vm.showing
  },on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('i',{staticClass:"fal fa-comment-alt-lines"}),_vm._v(" "),(_vm.amount)?_c('small',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.amount))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }